import React from 'react';

interface ApiContextProps {
    api: string;
}

const ApiContext = React.createContext<ApiContextProps>({} as ApiContextProps)

export { ApiContext };
export type { ApiContextProps };
